import { useState, memo } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CreatePartnershipModal from "../modals/Partnerships/CreatePartnershipModal";

const CreatePartnership = ({
  createPartnership,
  loading,
  error,
  availablePartnerships,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCreatePartnership = async (data) => {
    try {
      await createPartnership(data);
    } catch (error) {
      console.error(`Error al realizar el request: ${error}`);
    } finally {
      handleCloseModal();
    }
  };

  return (
    <>
      <Grid item md={2} xs={6}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} />
            ) : (
              <GroupAddIcon fontSize="small" />
            )
          }
        >
          {loading ? "Procesando..." : "Crear Alianza"}
        </Button>
      </Grid>
      <CreatePartnershipModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleCreatePartnership}
        loading={loading}
        availablePartnerships={availablePartnerships}
      />
    </>
  );
};

export default memo(CreatePartnership);